import { Pipe, PipeTransform } from '@angular/core';

import { Analysis } from 'app/providers/storage-api/analysis.service';

@Pipe({
  name: 'isAnalysisDisabled',
  pure: true,
  standalone: false,
})
export class IsAnalysisDisabledPipe implements PipeTransform {
  transform(analysis: Analysis): boolean {
    return (
      analysis.status === 'QUEUED' ||
      analysis.status === 'DELETED' ||
      analysis.status === 'DELETING'
    );
  }
}
